module.exports = __webpack_public_path__ + "static/media/rescore_logo.967a10ed.jpg";